/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Pressure from './pressure';
import PressureDetail from './pressure-detail';
import PressureUpdate from './pressure-update';
import PressureDeleteDialog from './pressure-delete-dialog';

const PressureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Pressure />} />
    <Route path="new" element={<PressureUpdate />} />
    <Route path=":id">
      <Route index element={<PressureDetail />} />
      <Route path="edit" element={<PressureUpdate />} />
      <Route path="delete" element={<PressureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PressureRoutes;
